let eq = 500;
let hdFlag = (window.innerWidth > 300)
let parent = document.getElementById("game");
let height = parent.offsetHeight;
let width = parent.offsetWidth;

let currentRatio = width / height;
let baseRatio = 1080/1920;
if(baseRatio) {
  width = height * baseRatio;
}


let ratio = height/ width;
let baseWidth = (hdFlag) ? Math.floor(1080 / 1.15) : Math.floor(240 / 1.15);
let baseHeight = Math.floor(baseWidth * ratio);

let speed = {
    "HD": {
        "hatchback": Math.floor(baseHeight * 0.6),
        "sedan": Math.floor(baseHeight * 0.6),
        "buggy": Math.floor(baseHeight * 0.5),
        "ambulance": Math.floor(baseHeight * 0.6),
        "fuel_truck": Math.floor(baseHeight * 0.6),
        "tank": Math.floor(baseHeight * 0.1),
        "battle_truck": Math.floor(baseHeight * 0.1),
        "road": Math.floor(baseHeight * 0.9),
        "obstacle": Math.floor(baseHeight * 0.9),
        "loot": Math.floor(baseHeight * 1.5),
        "player_touch": Math.floor(baseWidth * 0.0023),
        "player_key": Math.floor(baseWidth * 0.02),
        "missile": Math.floor(baseHeight * 2),
        "bullet_player": Math.floor(baseHeight * 0.7),
        "bullet_buggy": 2200,
        "bullet_battle_truck": 2000,
        "bullet_tank": 2000,
        "overhead": Math.floor(baseHeight * 0.1)
    },
    "SD": {
        "hatchback": Math.floor(baseHeight * 0.6),
        "sedan": Math.floor(baseHeight * 0.6),
        "buggy": Math.floor(baseHeight * 0.5),
        "ambulance": Math.floor(baseHeight * 0.6),
        "fuel_truck": Math.floor(baseHeight * 0.6),
        "tank": Math.floor(baseHeight * 0.1),
        "battle_truck": Math.floor(baseHeight * 0.1),
        "road": Math.floor(baseHeight * 0.9),
        "obstacle": Math.floor(baseHeight * 0.9),
        "loot": Math.floor(baseHeight * 1.5),
        "player_touch": Math.floor(baseWidth * 0.009),
        "player_key": Math.floor(baseWidth * 0.03),
        "missile": Math.floor(baseHeight * 2),
        "bullet_player": Math.floor(baseHeight * 0.9),
        "bullet_buggy": 360,
        "bullet_battle_truck": 360,
        "bullet_tank": 360,
        "overhead": Math.floor(baseHeight * 0.1)
    }
}

let rateOfFire = {
    "HD": {
        "bullet_player": 0.15,
        "bullet_buggy": 0.18,
        "bullet_battle_truck": 0.15,
        "bullet_tank": 0.3,
    },
    "SD": {
        "bullet_player": 0.15,
        "bullet_buggy": 0.18,
        "bullet_battle_truck": 0.15,
        "bullet_tank": 0.3,
    },
}

let rateOfRounds = {
    "HD": {
        "bullet_player": 2,
        "bullet_buggy": 2,
        "bullet_battle_truck": 2,
        "bullet_tank": 0.5,
    },
    "SD": {
        "bullet_player": 2,
        "bullet_buggy": 2,
        "bullet_battle_truck": 2,
        "bullet_tank": 0.5,
    }
}

let health = {
    "hatchback": 3,
    "sedan": 4,
    "buggy": 10,
    "ambulance": 3,
    "fuel_truck": 6,
    "tank": 50,
    "battle_truck": 30,
    "player": 10
}

let hitValue = {
    "bullet_buggy": 1,
    "bullet_battle_truck": 1,
    "bullet_tank": 1,
    "bullet_player": 1.3,
}

let hitScore = {
    "buggy": 5,
    "battle_truck": 10,
    "tank": 20,
    "fuel_truck": 4,
    "sedan": 3,
    "hatchback": 2,
    "ambulance": 2,
    "health_kit": 2,
    "coin_flip": 1
}

let powerUpDuration = {
    "magnet": 6,
    "shield": 6,
    "2x": 6,
    "turrets": 6,
    "split_shooter": 6,
    "laser": 6,
    "aimbot": 6
}

// must reduce the size of the colliders to make the collisions seem more good
let colliderOffset = {
    "hatchback": { width: 0.63, height: 0.82, x: 0.184, y: 0, cx: 0.527, cy: 0.41 },
    "sedan": { width: 0.747, height: 0.879, x: 0.126, y: 0, cx: 0.488, cy: 0.439 },
    "buggy": { width: 0.685, height: 0.857, x: 0.185, y: 0, cx: 0.497, cy: 0.428 },
    "ambulance": { width: 0.62, height: 0.91, x: 0.188, y: 0, cx: 0.5, cy: 0.456 },
    "fuel_truck": { width: 0.65, height: 0.865, x: 0.175, y: 0, cx: 0.525, cy: 0.432 },
    "tank": { width: 0.918, height: 0.89, x: 0.04, y: 0, cx: 0.51, cy: 0.445 },
    "battle_truck": { width: 0.669, height: 0.868, x: 0.165, y: 0, cx: 0.468, cy: 0.43 },
    "player": { width: 0.567, height: 0.8, x: 0.216, y: 0, cx: 0.489, cy: 0.4 },
    // "obstacle": { width: 0.736, height: 0.916, x: 0.13, y: 0, cx: 0.41, cy: 0.458 },
    "obstacle": { width: 0.674, height: 0.624, x: 0.163, y: 0, cx: 0.337, cy: 0.312 },
    // "obstacle": { width: 0.674, height: 0.53, x: 0.163, y: 0.064, cx: 0.337, cy: 0.312 },
    "health": { width: 0.68, height: 0.76, x: 0.158, y: 0.11, cx: 0.527, cy: 0.38 },
    "coin_flip": { width: 0.845, height: 0.92, x: 0.077, y: 0.038, cx: 0.5, cy: 0.5 },
    "missile": { width: 0.727, height: 0.82, x: 0.12, y: 0.1, cx: 0.39, cy: 0.48 },
    "bullet": { width: 0.31, height: 0.698, x: 0.34, y: 0.04, cx: 0.468, cy: 0.40 },
    "gun_player": { x: 0.5, y: 0.3, cx: 0.5, cy: 0.84 },
    "gun_tank": { x: 0.5, y: 0.5, cx: 0.5, cy: 0.845 },
    "gun_battle_truck": { x: 0.5, y: 0.35, cx: 0.48, cy: 0.87 },
    "gun_buggy": { x: 0.5, y: 0.4, cx: 0.5, cy: 0.84 },
}

export { speed, health, rateOfFire, rateOfRounds, hitScore, powerUpDuration, hitValue, colliderOffset };